// Enum for secondary action types
export enum SecondaryCtaAction {
  SIGN_IN = 'SIGN_IN',
  SUBSCRIBE = 'SUBSCRIBE',
  WAYSTOWATCH = 'WAYSTOWATCH',
  RELINK = 'RELINK',
}
